import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export interface ChevronProps extends Partial<IconProps> {
  direction?: keyof typeof directions;
}
export const Chevron = forwardRef<SVGSVGElement, ChevronProps>(function Chevron({
  title = 'chevron',
  description = 'chevron icon',
  direction = 'down',
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 24 24" title={title} description={description} ref={ref} {...props}>
      <path {...stylex.props([iconsStyles.neutralElement, localStyles.icon, directions[direction]])} d="M7.4 7.8l4.6 4.6 4.6-4.6L18 9.2l-6 6-6-6 1.4-1.4z" />
    </Icon>;
});
const localStyles = {
  icon: {
    kmkexE: "x1ux5q4u",
    k6sLGO: "x1so62im",
    k3nNDw: "x1g0ag68",
    $$css: true
  }
};
const directions = {
  up: {
    k3aq6I: "x135icu2",
    $$css: true
  },
  down: {
    $$css: true
  },
  left: {
    k3aq6I: "x1iffjtl",
    $$css: true
  },
  right: {
    k3aq6I: "x9tu13d",
    $$css: true
  }
};